import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import "../PaymentGeteway/PaymentGeteway.css"
import { PaymentElement, Elements, useStripe, useElements, } from "@stripe/react-stripe-js";
const stripePromise = loadStripe("pk_test_6pRNASCoBOKtIshFeQd4XMUh");
const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState(null);
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!elements) return;
    const { error: submitError } = await elements.submit();
    if (submitError) {
      setErrorMessage(submitError.message);
      return;
    }
    try {
      const res = await fetch("/create-intent", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      const { client_secret: clientSecret } = await res.json();
      const { error } = await stripe.confirmPayment({
        elements,
        clientSecret,
        confirmParams: {
          return_url: "https://example.com/order/123/complete",
        },
      });
      if (error) {
        setErrorMessage(error.message);
      }
    } catch (err) {
      setErrorMessage("An error occurred while processing your payment.");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <button className="payment-pay-btn" type="submit" disabled={!stripe || !elements}>
        Pay
      </button>
      {errorMessage && <div>{errorMessage}</div>}
    </form>
  );
};

const PaymentGateway = () => {
  const options = {
    mode: "payment",
    amount: 1099,
    currency: "usd",
    appearance: {},
  };

  return (
    <div className="payment-container">
      <h2 style={{marginBottom:"10px"}}>Payment</h2>
      <p className="text-aboutus">Our commitment to security is unwavering. As a trusted and private donation platform, we prioritize the safety of every transaction. Whether you're an individual contributor or part of a large organization, we implement robust measures to safeguard your sensitive information. We ensure the protection of not only your personal data but also the data of our athletes, schools, collectives, and local businesses, keeping everyone’s financial details secure and confidential.</p>
      <Elements stripe={stripePromise} options={options}>
        <CheckoutForm />
      </Elements>
    </div>
  );
};

export default PaymentGateway;
